<template>
  <div>
    <main-layout>
      <Users />
    </main-layout>
  </div>
</template>

<script>
import Users from './Users.vue'
export default {
  components: {
    Users
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Agentmanagement/main.vue